import { useState, useCallback } from "react";
import { getAuditLogs } from "../../../../api/marketplace";

export function useAuditLogs() {
  const [auditLogs, setAuditLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchAuditLogs = useCallback(async (params = {}) => {
    setLoading(true);
    setError(null);
    try {
      const res = await getAuditLogs(params);
      setAuditLogs(res.data);
    } catch (err) {
      setError(err.response?.data || err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    auditLogs,
    loading,
    error,
    fetchAuditLogs,
  };
}
